import { render, staticRenderFns } from "./SportelloTipiStudenteView.vue?vue&type=template&id=35cf17b2&"
import script from "./SportelloTipiStudenteView.vue?vue&type=script&lang=ts&"
export * from "./SportelloTipiStudenteView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports